module.controller('registerFeeScheduleCtrl', ['$scope', '$state', '$sce', function ($scope, $state, $sce) {
  var vm = this;

  var urlRoot = window.location.href.split('#')[0];
  var currentBrand = $scope.brand.name;
  vm.trustSrc = function(src) {
    return $sce.trustAsResourceUrl(src);
  };
  vm.goTo = goTo;
  vm.pdfSrc = urlRoot.replace('?', '') + 'assets/pdf/' + currentBrand + '/fee-schedule.pdf';
  vm.pdfGDSrc = 'https://docs.google.com/gview?embedded=true&url=' + encodeURIComponent(vm.pdfSrc);

  function goTo(nextStep) {
    $state.go(nextStep, {joinType: $scope.joinType});
  }
  vm.openModal = function(){
    vm.showModal = true;
  };

  vm.closeModal = function(){
    vm.showModal = false;
  };
}]);
